import { render, staticRenderFns } from "./OrderTransactionDetail.vue?vue&type=template&id=38389405"
import script from "./OrderTransactionDetail.vue?vue&type=script&lang=js"
export * from "./OrderTransactionDetail.vue?vue&type=script&lang=js"
import style0 from "./OrderTransactionDetail.vue?vue&type=style&index=0&id=38389405&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports